import type { ReactNode } from 'react'

// 操作记录项的数据结构
export interface OperationLogItem {
  id?: string
  operationType: number
  operationTypeName?: string
  operationDesc?: string
  operatorId?: string
  operatorUsername?: string
  operatorNickname?: string
  operationTime?: string
  beforeStatus?: number
  afterStatus?: number
  beforeStatusName?: string
  afterStatusName?: string
  [key: string]: any // 允许其他字段
}

// 状态信息接口
export interface StatusInfo {
  text: string
  color: string
  bgColor: string
}

// 操作类型常量
export const OPERATION_TYPES = {
  CREATE: 10,
  UPDATE: 20,
  PUBLISH: 30,
  WITHDRAW: 40,
  DELETE: 50,
  PUSH: 60,
} as const

// 组件属性接口
export interface OperationLogProps {
  // 数据相关
  data: OperationLogItem[]
  total: number
  current: number
  pageSize: number
  loading?: boolean
  
  // 回调函数
  onPageChange?: (page: number) => void
  onExport?: (data: OperationLogItem[]) => void
  
  // 自定义配置
  title?: string
  showStatistics?: boolean
  showQuickActions?: boolean
  showSearch?: boolean
  showExport?: boolean
  showPagination?: boolean
  
  // 自定义样式
  className?: string
  style?: React.CSSProperties
  
  // 自定义操作类型名称映射
  operationTypeNames?: Record<number, string>
  
  // 自定义状态映射
  statusMap?: Record<number, StatusInfo>
  
  // 自定义图标映射
  iconMap?: Record<number, ReactNode>
  
  // 自定义颜色主题
  themeColor?: string
  themeBgColor?: string
}

// 导出类型
export type { OperationLogItem, OperationLogProps, StatusInfo }
